import { splitOnMatches } from '../../../../../utility'
import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { ISimplifiedNode } from '../../../../../components/ingestion/IngestedTree'
import { prepareQuestionsMultiPart } from './questions'
import { IMActivity } from '../../../types'

export function parseTrickyMultipart(
  {
    statement,
    studentResponse,
  }: {
    statement?: string
    studentResponse?: string
  },
  activity?: IMActivity,
) {
  if (!statement) return
  const multiQRegex = /<p>\d\.\s/g
  const questionParts = splitOnMatches(statement, multiQRegex)
  if (questionParts.length < 2) return
  const answerParts = Array.from(
    parseHtmlString(studentResponse ?? '')
      .getElementsByTagName('ol')
      .item(0)?.children ?? [],
  )
  if (answerParts.length !== questionParts.length) {
    return
  }
  return questionParts.reduce<ISimplifiedNode[]>((acc, statement, index) => {
    return [
      ...acc,
      ...prepareQuestionsMultiPart(
        {
          statement,
          student_response: answerParts[index].innerHTML,
        },
        activity,
      ),
    ]
  }, [])
}
